export enum DrawingMode {
  SimpleSelect = "simple_select",
  DrawPolygon = "draw_polygon",
  DirectSelect = "direct_select",
  HiddenMode = "hidden_mode",
}

export const hiddenMode = { toDisplayFeatures: () => {} };
